import { useTranslation } from '@sortlist-frontend/translation/ssr';
import { Fragment } from 'react';

import { BriefingEmbedButton } from '_components/Briefing/components/BriefingEmbedButton';
import { ComparatorButtonEmbed } from '_components/Comparator/Menu/ComparatorButtonEmbed';
import { SearchTopics } from '_components/SearchTopic/SearchTopics';
import { Expertise } from '_core/repos/expertises.repo';
import { customConfig } from '_features/custom/custom.config';
import { Links, Page } from '_types/public-api';

import { Layout, LayoutProps, NavigationData } from './Layout';
import { SubNav } from './SubNav';

type LayoutData = {
  page?: Page | null;
  homepageLinks?: Links | null;
  expertises?: Expertise[];
};

type Props = {
  navigationData: NavigationData;
  data: LayoutData;
};

export const LayoutPagesRouterLight = (props: LayoutProps & Props) => {
  const { navigationData, data, children, ...restProps } = props;

  const { t } = useTranslation(customConfig.i18nNamespaces);

  const { expertises, homepageLinks, page } = data;

  const expertiseId = page?.data?.attributes?.briefing_options?.expertise?.id;

  return (
    <Layout
      links={homepageLinks ?? undefined}
      expertises={expertises}
      navigationData={navigationData}
      showRankUpdated
      t={t}
      briefingCTA={
        <BriefingEmbedButton
          data-testid="briefing-button-navbar-project"
          size="sm"
          buttonStyle="primary"
          buttonVariant="raised"
          className="mx-2"
          label={t('common:navbar.menu.postAProject')}
          truncate={false}
          cta="navbar-need"
          expertiseId={expertiseId}
        />
      }
      comparatorCTA={<ComparatorButtonEmbed title={t('common:comparator.myShortlist')} />}
      search={
        <SearchTopics
          type="service"
          cta="hero"
          page="search-landing"
          element="search-landing"
          placeholder={t('common:navbar.menu.whatService')}
          navigationData={navigationData}
        />
      }
      searchMobile={
        <SearchTopics
          type="service"
          cta="hero"
          page="search-landing"
          element="search-landing"
          placeholder={t('common:navbar.menu.whatService')}
          navigationData={navigationData}
          mobile
        />
      }
      {...restProps}>
      <Fragment>
        <SubNav otherString={t('home:sections.catalog.others_v1')} links={homepageLinks ?? undefined} />
        {children}
      </Fragment>
    </Layout>
  );
};
